"use client";
import { createContext } from "react";
const DrawerInsetContext = createContext(null);
export { DrawerInsetContext };
